<div
  class="element-wrapper {{ elementActionsKeyRoot }} {{ elementActionsKey }}"
  [ngStyle]="wrapperStyles"
>
  <div class="header">
    <blaze-element-filter-header
      (addButtonClick)="onAddNewRow($event)"
      [addButtonBlocked]="!itemAddEnabled()"
      [addButtonCssClasses]="getActionClasses(itemAdd.styleSheetTarget ?? itemAdd.styleSheetId)"
      [addButtonEnabled]="itemAddEnabled()"
      [addButtonLabel]="itemAdd.label"
      [fontColor]="props?.style?.general?.heading?.color1"
      [labelEnabled]="labelEnabled"
      [labelFontFamily]="props?.style?.titleBlock?.fontFamily"
      [labelFontSize]="props?.style?.titleBlock?.fontSize"
      [labelFontStyle]="props?.style?.titleBlock?.fontStyle"
      [labelFontWeight]="props?.style?.titleBlock?.fontWeight"
      [labelIconAlign]="props?.content?.title?.iconPosition"
      [labelIconSize]="props?.style?.titleBlock?.iconSize"
      [labelIconColor]="props?.content?.title?.iconColor?.color1"
      [labelIcon]="labelIcon"
      [labelTextAlign]="props?.content?.title?.align"
      [labelText]="labelText"
      [searchAndFilters]="props?.content?.searchAndFilters"
      [slots]="slots"
    />
  </div>

  <blaze-scroller>
    @let boardData = (boardData$ | async) || [];
    @let visibleRowCustomFields = (visibleRowCustomFields$ | async) || {};
    @let visibleRowActions = (elementDataActions.visibleRowActions$ | async) || {};

    <div
      #boardContainer
      class="board-container actions-{{ actionsDisplayMode }}"
      [class.draggable]="itemDragDropEnabled()"
    >
      @if (!boardData.length && (isPending$ | async) === false) {
        <div class="board-notification empty">
          <span>No Data</span>
        </div>
      }

      @if (boardData.length) {
        <ul #columnsList class="columns-list" cdkDropListGroup>
          @for (column of boardData; track column; let i = $index) {
            <li class="columns-item">
              <div class="column-header">
                <h4 class="column-name" [style]="columnNameStyles[i]">
                  {{ column.displayName }} ({{ column.cards.length }})
                </h4>
              </div>
              @if (shouldShowCardsList) {
                <ul
                  class="cards-list"
                  cdkDropList
                  [cdkDropListData]="[column.displayName]"
                  cdkDropListSortingDisabled
                  (cdkDropListDropped)="onDrop($any($event))"
                >
                  @for (card of column.cards; track card) {
                    <li
                      class="cards-item"
                      (click)="onViewRow($event, card.value)"
                      cdkDrag
                      [cdkDragData]="card.value[cardIdField]"
                      [cdkDragDisabled]="!itemDragDropEnabled()"
                      cdkDragPreviewContainer="parent"
                      (cdkDragStarted)="dragMoved($event)"
                      (cdkDragMoved)="dragMoved($event)"
                    >
                      @if (cardTitleField) {
                        <h5 class="card-name">
                          {{
                            card.value
                              | dataRowFieldValuePipe: cardTitleField
                              | formatValue: cardTitleFieldFormat : cardTitleFieldFormatOptions
                          }}
                        </h5>
                      }
                      @if (cardDescriptionField) {
                        <p class="card-description">
                          {{
                            card.value
                              | dataRowFieldValuePipe: cardDescriptionField
                              | formatValue
                                : cardDescriptionFieldFormat
                                : cardDescriptionFieldFormatOptions
                          }}
                        </p>
                      }
                      <ng-container
                        [ngTemplateOutlet]="customFieldsTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: card,
                          visibleRowCustomFields: visibleRowCustomFields,
                        }"
                      />
                      <ng-container
                        [ngTemplateOutlet]="actionsTpl"
                        [ngTemplateOutletContext]="{
                          $implicit: card,
                          actions: actionsList,
                          visibleRowActions: visibleRowActions,
                        }"
                      />
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      }
    </div>
  </blaze-scroller>
</div>

<ng-template #customFieldsTpl let-card let-visibleRowCustomFields="visibleRowCustomFields">
  @if (visibleRowCustomFields[card.index]?.length) {
    <div class="custom-fields">
      @for (field of visibleRowCustomFields[card.index]; track field; let i = $index) {
        <div
          class="custom-field-item label-{{ field.labelBehavior }} format-{{ field.displayFormat }}"
        >
          @if (field.label) {
            <div class="label">{{ field.label }}</div>
          }
          <div class="value">
            @switch (field.displayFormat ?? field.format) {
              @case ('tag') {
                <blaze-tags-column-value
                  class="tags"
                  [value]="card.value | dataRowFieldValuePipe: getColumnName(field.column) || ''"
                  [palette]="tagConfig[i]?.palette"
                  [order]="tagConfig[i]?.order"
                />
              }
              @case ('signature') {
                <blaze-signature-column-value
                  [signature]="
                    $any(card.value | dataRowFieldValuePipe: getColumnName(field.column) || '')
                  "
                />
              }
              @case ('checkbox') {
                @let isChecked =
                  card.value | dataRowFieldValuePipe: field.columnName | formatValue: 'checkbox';
                <mat-icon
                  class="col-boolean"
                  [class.checked]="isChecked"
                  svgIcon="{{ isChecked ? 'icon_boolean_on_24' : 'icon_boolean_off_24' }}"
                />
              }
              @default {
                @if (getColumnName(field.column)) {
                  @let value =
                    card.value
                      | dataRowFieldValuePipe: getColumnName(field.column) || ''
                      | formatValue
                        : field.displayFormat
                        : {
                            precision: field.precision,
                            currency: field.currency,
                            durationFormat: field.duration || 'h:mm',
                            dateFormat: field.dateFormat,
                            dateTimeFormat: field.dateTimeFormat,
                          };
                  <!-- Keep this in one line! -->
                  <span (click)="columTypeClicked(field.displayFormat, value)">{{ value }}</span>
                }
              }
            }
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #actionsTpl let-item let-actions="actions" let-visibleRowActions="visibleRowActions">
  @if (visibleRowActions?.[item.index]?.length) {
    <div class="actions" [ngStyle]="actionsContainerStyles">
      <ng-container
        [ngTemplateOutlet]="actionsGrouped ? actionsGroupedTpl : actionsListedTpl"
        [ngTemplateOutletContext]="{
          $implicit: item.value,
          actions: visibleRowActions[item.index],
        }"
      />
    </div>
  }

  <ng-template #actionsListedTpl let-actions="actions">
    @for (action of actions; track action) {
      <button
        class="action-item"
        [ngClass]="getActionClasses(action.styleSheetTarget ?? action.styleSheetId)"
        [class.icon-right]="action.iconPosition === 'right'"
        [class.icon-only]="action.icon && !action.label"
        (click)="onAction({ event: $event, action, dataRow: item.value })"
      >
        @if (action.icon) {
          <mat-icon [svgIcon]="action.icon" />
        }
        {{ action.label }}
      </button>
    }
  </ng-template>

  <ng-template #actionsGroupedTpl let-actions="actions">
    <button
      blazeClickable
      blazeIconButton
      [matMenuTriggerFor]="actionsMenu"
      (click)="$event.stopPropagation()"
    >
      <mat-icon svgIcon="icon_more_h_24" />
    </button>
    <mat-menu #actionsMenu="matMenu" xPosition="before" class="bd-menu-actions b-kbn-am-dd">
      <ng-template matMenuContent>
        @for (action of actions; track action) {
          <button
            mat-menu-item
            disableRipple
            [class.icon-right]="action.iconPosition === 'right'"
            (click)="onAction({ event: $event, action, dataRow: item.value })"
          >
            @if (action.icon) {
              <mat-icon [svgIcon]="action.icon" />
            }
            {{ action.label }}
          </button>
        }
      </ng-template>
    </mat-menu>
  </ng-template>
</ng-template>
